import { render, staticRenderFns } from "./desiredPayment.vue?vue&type=template&id=1a4485f6&scoped=true&"
import script from "./desiredPayment.vue?vue&type=script&lang=js&"
export * from "./desiredPayment.vue?vue&type=script&lang=js&"
import style0 from "./desiredPayment.vue?vue&type=style&index=0&lang=css&"
import style1 from "./desiredPayment.vue?vue&type=style&index=1&id=1a4485f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4485f6",
  null
  
)

export default component.exports